import { Link } from "react-router-dom";
import { ArrowRight, Wind, Thermometer, Zap, Droplets, Layout, FileText } from "lucide-react";
import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";
import { SEO } from "../components/SEO";
import { heatingDesignServices } from "../mockData";

export const DesignTechnical = () => {
  return (
    <div className="min-h-screen bg-navy-900 pt-20">
      <SEO 
        title="Design & Technical | Magic C Plumbing | Plumber & Heating Engineer in London"
        description="Professional 3D design, technical planning, and heat pump integration for your luxury bathroom and heating projects. Precision engineering meets aesthetic excellence."
        canonical="/design-technical"
      />
      {/* Hero */}
      <section className="py-24 bg-gradient-to-b from-navy-900 to-gray-900">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
              Design & Technical Excellence
            </h1>
            <p className="text-2xl text-gray-300 leading-relaxed">
              Precision-engineered heating and plumbing systems with cutting-edge 3D technical design and planning
            </p>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-24 bg-navy-900">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Our Technical Services
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
            {heatingDesignServices.map((service) => {
              const IconComponent = { Wind, Thermometer, Zap, Droplets, Layout, FileText }[service.icon];
              
              return (
                <Card key={service.id} className="bg-white/5 backdrop-blur-md border-white/10 hover:bg-white/10 transition-all group">
                  <CardContent className="p-8">
                    <div className="bg-sage-500/20 group-hover:bg-sage-500 w-20 h-20 rounded-2xl flex items-center justify-center mb-6 transition-all">
                      <IconComponent className="h-10 w-10 text-sage-400 group-hover:text-white transition-colors" />
                    </div>
                    <h3 className="text-2xl font-bold text-white mb-4">
                      {service.title}
                    </h3>
                    <p className="text-gray-300 leading-relaxed text-lg">
                      {service.description}
                    </p>
                  </CardContent>
                </Card>
              );
            })}
          </div>

          <div className="text-center mt-16">
            <Link to="/contact">
              <Button size="lg" className="bg-sage-600 hover:bg-sage-700 text-white text-lg px-10 py-7">
                Schedule a Site Visit
                <ArrowRight className="ml-2 h-6 w-6" />
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};
